module.exports = __webpack_public_path__ + "static/media/knife.f6f5bbe0.png";